import React from 'react';
import {
  BsFillCloudArrowDownFill,
  BsSearch,
  BsFillPenFill,
  BsFillTrashFill,
  BsBookHalf,
  BsFillXCircleFill,
  BsSave2Fill,
  BsPrinterFill,
  BsFillCheckCircleFill,
  BsLockFill,
  BsArrowLeftCircleFill,
  BsFillPlusCircleFill,
  BsArrowClockwise,
  BsShieldFillCheck,
  BsPersonCheckFill,
  BsKanban,
  BsJournalBookmarkFill,
  BsLayoutSidebarInsetReverse,
  BsEye,
  BsTruck,
} from 'react-icons/bs';
import {
  RiLogoutBoxRFill,
  RiLoginBoxFill,
  RiExchangeLine,
  RiTicket2Fill,
  RiFileTransferFill,
  RiCheckFill,
} from 'react-icons/ri';
import {
  IoSettingsOutline,
  IoBookmarks,
  IoAlertCircleSharp,
  IoCheckbox,
  IoTimeOutline,
} from 'react-icons/io5';
import { HiDotsCircleHorizontal } from 'react-icons/hi';
import {
  FaAngleDoubleLeft,
  FaBook,
  FaBoxOpen,
  FaChevronCircleDown,
  FaCut,
  FaExternalLinkAlt,
  FaFileAlt,
  FaHourglass,
  FaLine,
  FaList,
  FaPaperPlane,
  FaQrcode,
  FaRegistered,
  FaStore,
  FaTimes,
  FaUsers,
} from 'react-icons/fa';
import { MdWavingHand } from 'react-icons/md';
import { FiChevronRight } from 'react-icons/fi';
import { EditFilled } from '@ant-design/icons';
/**
 * React Icons --> https://react-icons.github.io/react-icons/
 */
export const Icon = {
  download: (props) => <BsFillCloudArrowDownFill {...props} />,
  search: (props) => <BsSearch {...props} />,
  edit: (props) => <BsFillPenFill {...props} />,
  remove: (props) => <BsFillTrashFill {...props} />,
  view: (props) => <BsBookHalf {...props} />,
  clear: (props) => <BsFillXCircleFill {...props} />,
  cancel: (props) => <BsFillXCircleFill {...props} />,
  logout: (props) => <RiLogoutBoxRFill {...props} />,
  login: (props) => <RiLoginBoxFill {...props} />,
  save: (props) => <BsSave2Fill {...props} />,
  print: (props) => <BsPrinterFill {...props} />,
  confirm: (props) => <BsFillCheckCircleFill {...props} />,
  forgetPassword: (props) => <BsLockFill {...props} />,
  back: (props) => <BsArrowLeftCircleFill {...props} />,
  create: (props) => <BsFillPlusCircleFill {...props} />,
  reAct: (props) => <BsArrowClockwise {...props} />,
  recheck: (props) => <BsShieldFillCheck {...props} />,
  register: (props) => <BsPersonCheckFill {...props} />,
  settings: (props) => <IoSettingsOutline {...props} />,
  threeDots: (props) => <HiDotsCircleHorizontal {...props} />,
  downCircle: (props) => <FaChevronCircleDown {...props} />,
  bookmark: (props) => <IoBookmarks {...props} />,
  alert: (props) => <IoAlertCircleSharp {...props} />,
  checkboxSquare: (props) => <IoCheckbox {...props} />,
  wavingHand: (props) => <MdWavingHand {...props} />,
  external: (props) => <FaExternalLinkAlt {...props} />,
  box: (props) => <FaBoxOpen {...props} />,
  edit2: (props) => <EditFilled {...props} />,
  detail: (props) => <BsEye {...props} />,
  doubleLeft: (props) => <FaAngleDoubleLeft {...props} />,
  line: (props) => <FaLine {...props} />,
  evernote: (props) => <FaBook {...props} />,
  hourglass: (props) => <FaHourglass {...props} />,
  truck: (props) => <BsTruck {...props} />,
  paperPlane: (props) => <FaPaperPlane {...props} />,
  times: (props) => <FaTimes {...props} />,
  change: (props) => <RiExchangeLine {...props} />,
  users: (props) => <FaUsers {...props} />,
  store: (props) => <FaStore {...props} />,
  ticket: (props) => <RiTicket2Fill {...props} />,
  list: (props) => <FaList {...props} />,
  expired: (props) => <IoTimeOutline {...props} />,
  transfer: (props) => <RiFileTransferFill {...props} />,
  check: (props) => <RiCheckFill {...props} />,

  /** MENU ICON */
  dashboard: (props) => <BsKanban {...props} />,
  todo: (props) => <BsJournalBookmarkFill {...props} />,
  formExample: (props) => <BsLayoutSidebarInsetReverse {...props} />,
  registered: (props) => <FaRegistered {...props} />,
  fileSearch: (props) => <FaFileAlt {...props} />,
  qrcode: (props) => <FaQrcode {...props} />,
  cut: (props) => <FaCut {...props} />,
};

export const StepIcon = () => {
  return <FiChevronRight size={20} style={{ color: 'grey' }} />;
};
